import React from 'react';
import { Link } from 'react-router-dom';
import { BRANCHES } from '../data/catalog';
import AlphaLoop from './objects/AlphaLoop';
import { TUTORS } from '../data/tutors';
import TutorCard from './TutorCard';
import '../styles/Tutors.css';

/** One featured tutor per branch on the home page. */
const FEATURED = ['jm', 'dt', 'lc'];

const TutorsSection: React.FC = () => {
  const featured = TUTORS.filter(tutor => FEATURED.includes(tutor.id));

  return (
    <section id="tutors" className="section tutors">
      <div className="obj-spot spot-steps" aria-hidden="true"><AlphaLoop slug="steps" /></div>
      <div className="container">
        <div className="section-head" data-reveal>
          <p className="section-eyebrow">Our tutors</p>
          <h2 className="section-title">Gain an advantage over your other applicants.</h2>
          <p className="section-intro">
            Our tutors are current employees working in the industry
            you&apos;re applying to. They&apos;ve been in the seats of your
            interviewers and they can help you gain an edge.
          </p>
        </div>

        <div className="tutor-grid">
          {featured.map((tutor, index) => (
            <TutorCard key={tutor.id} tutor={tutor} revealDelay={index * 0.1} />
          ))}
        </div>

        <div className="tutor-links" data-reveal>
          {BRANCHES.map(branch => (
            <Link key={branch.id} to={`/${branch.id}#tutors`} className="tutor-link">
              All {branch.shortName} tutors →
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TutorsSection;
